import { create } from "zustand"
import { DataTypeSetStockByLocationType } from "../types"

type SelectedSalaryState = {
    selectedRows: DataTypeSetStockByLocationType[]
    toggleRow: (row: DataTypeSetStockByLocationType, checked: boolean) => void
    toggleAll: (rows: DataTypeSetStockByLocationType[], checked: boolean) => void
    clear: () => void
}

export const useStoreSelectedRows = create<SelectedSalaryState>((set) => ({
    selectedRows: [],

    toggleRow: (row, checked) =>
        set((state ) => {
            if (checked) {
                const exists = state.selectedRows.some(
                    r => r.product_id === row.product_id
                )
                if (exists) return state

                return { selectedRows: [...state.selectedRows, row] }
            }

            return {
                selectedRows: state.selectedRows.filter(
                    r => r.product_id !== row.product_id
                ),
            }
        }),

    toggleAll: (rows, checked) =>
        set(state => {
            if (!checked) {
                return {
                    selectedRows: state.selectedRows.filter(
                        r => !rows.some(row => row.product_id === r.product_id)
                    ),
                }
            }

            const existingIds = new Set(
                state.selectedRows.map(r => r.product_id)
            )

            const newRows = rows.filter(
                row => !existingIds.has(row.product_id)
            )

            return {
                selectedRows: [...state.selectedRows, ...newRows],
            }
        }),


    clear: () => set({ selectedRows: [] }),
}))
